import { combineReducers } from 'redux';
import { reducers } from 'sdk';

//if needed we can put up more reducers here.
export default combineReducers({
    ...reducers
});
